export default __webpack_public_path__ + "static/Layer_3-77ecec162e3855a822fbc54984ff0cd3.png";